/**
 * Resolves English swatch image URLs on translated storefronts by fetching
 * the market's English-locale product.js and mapping option position + value index.
 */
(function () {
  if (typeof window.initSwatchEnglishImages === "function") return;

  var productJsCache = {};

  function slugifySwatchPart(text) {
    if (text == null) return "";
    return String(text)
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/\(/g, "_")
      .replace(/\)/g, "_")
      .replace(/\//g, "_")
      .replace(/"/g, "_")
      .replace(/&/g, "_")
      .replace(/è/g, "e")
      .replace(/d’/g, "d")
      .replace(/d`/g, "d")
      .replace(/ê/g, "e")
      .replace(/é/g, "e")
      .replace(/ç/g, "c")
      .replace(/\+/g, "_");
  }

  function buildSwatchSlugs(swatchName, swatchValue, productId) {
    var base;
    if (swatchName) {
      base = slugifySwatchPart(swatchName + "-" + swatchValue);
    } else {
      base = slugifySwatchPart(swatchValue);
    }
    base = base.replace(/_\./g, ".");
    var fallback = base + ".jpg";
    var primary = productId ? base + "-" + productId + ".jpg" : fallback;
    return { primary: primary, fallback: fallback };
  }

  function getCdnBase(container) {
    var base = container.getAttribute("data-swatch-cdn-base");
    if (base) return base;
    var sample = container.querySelector("[data-swatch-fallback], [data-swatch-primary]");
    if (sample) {
      var url =
        sample.getAttribute("data-swatch-fallback") || sample.getAttribute("data-swatch-primary") || "";
      var idx = url.lastIndexOf("/");
      if (idx !== -1) return url.slice(0, idx + 1);
    }
    return "/cdn/shop/files/";
  }

  function getEnglishOptionValues(product, position) {
    var key = "option" + position;
    var values = [];
    var seen = {};
    (product.variants || []).forEach(function (variant) {
      var val = variant[key];
      if (val != null && val !== "" && !Object.prototype.hasOwnProperty.call(seen, val)) {
        seen[val] = true;
        values.push(val);
      }
    });
    return values;
  }

  function getEnglishValue(product, position, valueIndex) {
    var options = product.options || [];
    var opt = options[position - 1];
    if (opt && typeof opt === "object" && opt.values && opt.values[valueIndex]) {
      return opt.values[valueIndex];
    }
    return getEnglishOptionValues(product, position)[valueIndex];
  }

  function looksLocalized(value) {
    if (value == null || value === "") return true;
    // Non-ASCII letters usually mean Translate & Adapt values — wrong locale served.
    return /[^\x00-\x7F]/.test(String(value));
  }

  function currentProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  /**
   * Turn any product href into a same-origin product.js path.
   * Hreflang tags are absolute (https://desky.eu/...) while theme preview runs on
   * 127.0.0.1 — comparing origins would drop every candidate.
   */
  function productJsPathFromHref(href) {
    try {
      var url = new URL(href, window.location.origin);
      if (url.pathname.indexOf("/products/") === -1) return "";
      return url.pathname.replace(/\/?$/, "") + ".js" + url.search;
    } catch (e) {
      return "";
    }
  }

  function isRootProductJsPath(jsPath) {
    return /^\/products\/[^/]+\.js/.test(jsPath.split("?")[0] || "");
  }

  /**
   * Prefer English alternate (hreflang="en" or "en-DE" + EN handle).
   * Theme remaps Shopify's language-only "en" to "en-DE".
   */
  function englishProductJsCandidates() {
    var links = document.querySelectorAll('link[rel="alternate"][hreflang]');
    var currentHandle = currentProductHandle();
    var sameHostEn = [];
    var exactEn = [];
    var rootOtherHandle = [];
    var otherHandle = [];
    var rest = [];

    for (var i = 0; i < links.length; i++) {
      var hreflang = (links[i].getAttribute("hreflang") || "").toLowerCase();
      var href = links[i].getAttribute("href") || "";
      if (!href || (hreflang !== "en" && hreflang.indexOf("en-") !== 0 && hreflang !== "x-default")) {
        continue;
      }

      var jsPath = productJsPathFromHref(href);
      if (!jsPath) continue;

      var handleMatch = jsPath.match(/\/products\/([^/?#]+)\.js/);
      var linkHandle = handleMatch ? decodeURIComponent(handleMatch[1]) : "";
      var score = {
        jsPath: jsPath,
        hreflang: hreflang,
        handle: linkHandle,
      };

      // desky.fr / desky.at serve their own language at the root and English under /en/,
      // so en-DE's path fetched on these hosts returns French/German. Prefer the EN
      // alternate on the current host (en-FR, en-AT; on desky.eu en-DE itself).
      var sameHost = false;
      try {
        sameHost = hreflang !== "x-default" && new URL(href, window.location.origin).host === window.location.host;
      } catch (e) {}

      if (sameHost) {
        sameHostEn.push(score);
      } else if (hreflang === "en" || hreflang === "en-de") {
        exactEn.push(score);
      } else if (linkHandle && currentHandle && linkHandle !== currentHandle) {
        if (isRootProductJsPath(jsPath)) rootOtherHandle.push(score);
        else otherHandle.push(score);
      } else {
        rest.push(score);
      }
    }

    var ordered = sameHostEn.concat(exactEn).concat(rootOtherHandle).concat(otherHandle).concat(rest);
    var seen = {};
    var urls = [];
    ordered.forEach(function (item) {
      if (seen[item.jsPath]) return;
      seen[item.jsPath] = true;
      urls.push(item.jsPath);
    });
    return urls;
  }

  function applySwatchUrls(el, primaryFile, fallbackFile, cdnBase) {
    var primaryUrl = cdnBase + primaryFile;
    var fallbackUrl = cdnBase + fallbackFile;
    el.setAttribute("data-swatch-primary", primaryUrl);
    el.setAttribute("data-swatch-fallback", fallbackUrl);
    el.style.backgroundImage = "url('" + fallbackUrl + "')";
    el.style.backgroundSize = "cover";
    el.style.backgroundPosition = "center";
    el.removeAttribute("data-needs-en-resolve");

    // Prefer product-specific file when it exists; keep generic as the visible default.
    var generation = String((parseInt(el.getAttribute("data-swatch-paint-gen"), 10) || 0) + 1);
    el.setAttribute("data-swatch-paint-gen", generation);
    var img = new Image();
    img.onload = function () {
      if (el.getAttribute("data-swatch-paint-gen") !== generation) return;
      if (el.getAttribute("data-swatch-primary") !== primaryUrl) return;
      el.style.backgroundImage = "url('" + primaryUrl + "')";
    };
    img.src = primaryUrl;
  }

  function paintTargetsFromProduct(targets, product, cdnBase, defaultProductId) {
    var applied = 0;
    var localizedHits = 0;

    targets.forEach(function (el) {
      var position = parseInt(el.getAttribute("data-option-position"), 10);
      var valueIndex = parseInt(el.getAttribute("data-value-index"), 10);
      var optName = el.getAttribute("data-canonical-option-name") || "";
      // The section setting can be translated per market (desky.fr "Couleur du plateau",
      // desky.at "Beinfarbe"); file names use the English product option name.
      if (el.classList.contains("swatch-image")) {
        var enOption = (product.options || [])[position - 1];
        var enOptName = enOption && typeof enOption === "object" ? enOption.name : enOption;
        if (enOptName && !looksLocalized(enOptName)) optName = enOptName;
      }
      var productId = el.getAttribute("data-product-id") || defaultProductId;

      if (!position || isNaN(valueIndex)) return;

      var enValue = getEnglishValue(product, position, valueIndex);
      if (!enValue) return;
      if (looksLocalized(enValue)) {
        localizedHits += 1;
        return;
      }

      var slugs = buildSwatchSlugs(optName, enValue, productId);
      applySwatchUrls(el, slugs.primary, slugs.fallback, cdnBase);
      applied += 1;
    });

    return {
      applied: applied,
      localizedHits: localizedHits,
      total: targets.length,
      ok: applied > 0 && localizedHits === 0,
    };
  }

  function paintContainerFromProduct(container, product) {
    var cdnBase = getCdnBase(container);
    var defaultProductId = container.getAttribute("data-product-id") || "";
    var targets = container.querySelectorAll(
      ".swatch-image[data-option-position][data-value-index], .ct-param-swatch[data-option-position][data-value-index], [data-needs-en-resolve][data-option-position][data-value-index]"
    );
    return paintTargetsFromProduct(targets, product, cdnBase, defaultProductId);
  }

  function fetchProductJs(url) {
    if (productJsCache[url]) return productJsCache[url];
    productJsCache[url] = fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error("en product.js " + res.status);
        return res.json();
      })
      .catch(function (err) {
        delete productJsCache[url];
        throw err;
      });
    return productJsCache[url];
  }

  function tryUrls(urls, container) {
    var chain = Promise.reject(new Error("no urls"));
    urls.forEach(function (url) {
      chain = chain.catch(function () {
        return fetchProductJs(url).then(function (product) {
          var result = paintContainerFromProduct(container, product);
          if (!result.ok) throw new Error("not english product.js");
          return result;
        });
      });
    });
    return chain.catch(function () {
      // Keep Liquid-canonical paint from desk-swatch-image when EN product.js fails.
    });
  }

  function collectCandidateUrls(containers) {
    var urls = [];
    var seen = {};
    function push(url) {
      if (!url || seen[url]) return;
      seen[url] = true;
      urls.push(url);
    }
    containers.forEach(function (container) {
      push((container.getAttribute("data-en-product-js") || "").trim());
    });
    englishProductJsCandidates().forEach(push);
    return urls;
  }

  function resolveContainer(container, sharedUrls) {
    var urls = [];
    var enUrl = (container.getAttribute("data-en-product-js") || "").trim();
    if (enUrl) urls.push(enUrl);
    (sharedUrls || englishProductJsCandidates()).forEach(function (url) {
      if (urls.indexOf(url) === -1) urls.push(url);
    });
    if (!urls.length) return Promise.resolve();
    return tryUrls(urls, container);
  }

  function initSwatchEnglishImages() {
    var containers = document.querySelectorAll("[data-en-product-js], [data-needs-en-swatch-resolve]");
    if (!containers.length) return Promise.resolve();

    var sharedUrls = collectCandidateUrls(containers);
    var promises = [];
    containers.forEach(function (container) {
      promises.push(resolveContainer(container, sharedUrls));
    });
    return Promise.all(promises);
  }

  window.initSwatchEnglishImages = initSwatchEnglishImages;
  window.buildSwatchSlugs = buildSwatchSlugs;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSwatchEnglishImages);
  } else {
    initSwatchEnglishImages();
  }
})();
